import CONST from '@/config/constant-home';
import apiClient from '@/utility/api_client';

export default {
  name: 'home',
  data() {
    return {
      config: {
        img: {
          section1: CONST.URL.ASSETS.IMG.BG_SECTION_1,
          section2: CONST.URL.ASSETS.IMG.BG_SECTION_2,
          section3: CONST.URL.ASSETS.IMG.BG_SECTION_3,
          // section4: CONST.URL.ASSETS.IMG.BG_SECTION_4,
          section5: CONST.URL.ASSETS.IMG.BG_SECTION_5,
          section6: CONST.URL.ASSETS.IMG.BG_SECTION_6,
          section7: CONST.URL.ASSETS.IMG.BG_SECTION_7,
        },
        map: {
          mapType: 'roadmap',
          center: {
            lat: 37.606173,
            lng: 140.357114,
          },
          maker: {
            pos: { lat: 37.606173, lng: 140.357114 },
          },
          options: {
            mapTypeControl: false,
          },
        },
        contact: {
          to: CONST.CONTACT.TO,
          types: [
            {
              id: 'shopType',
              label: 'お土産について',
            },
            {
              id: 'elseType',
              label: 'その他',
            },
          ],
        }
      },
      shopItems: [
        {
          img: CONST.URL.ASSETS.IMG.SHOP_ITEM_1,
          url: 'https://satobussanec.base.shop/items/45842956',
          name: '福島の温泉たまご「とろんたま」',
        },
        {
          img: CONST.URL.ASSETS.IMG.SHOP_ITEM_2,
          url: 'https://satobussanec.base.shop/items/45843245',
          name: '福島県産熟成醤油使用　温泉たまごのたれ',
        },
      ],
      contact: {
        type: {
          value: 'shopType',
        },
        email: {
          value: '',
          invalid: {
            format: false,
            require: false,
          },
        },
        content: {
          value: '',
          invalid: {
            require: false,
          },
        },
        isProgress: false,
        isInvalid: true,
        isAlreadyLimit: false,
      },
      btnTop: {
        isShow: false,
      },
      alertMessages: [],
      isLoaded: false,
      isOver: {
        section1: true,
        section2: false,
        section3: false,
        section4: false,
        section5: false,
        section6: false,
        section7: false,
      },
    };
  },

  computed: {
    mailTo() {
      const self = this;
      const type = self.getTypeLabel() || '';
      const content = self.contact.content.value || '';
      return [
        'mailto:',
        CONST.CONTACT.TO,
        '?',
        `subject=【佐藤物産館HPお問い合わせ】 ${type}`,
        `&body=${content}`,
      ].join('');
    },

    submitDisable() {
      const self = this;
      return (
        self.contact.isAlreadyLimit ||
        self.contact.isInvalid ||
        self.contact.isProgress
      );
    },
  },

  created() {
    const self = this;
    // お問い合わせの送信上限チェック
    const lastTime = localStorage.getItem('lastContactTime');
    const dayTime = 86400000;
    const currentTime = self._.now();
    if (!self._.isNull(lastTime) &&
        (parseInt(lastTime, 10) >= (currentTime - dayTime))) {
      self.contact.isAlreadyLimit = true;
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    const self = this;

    // 各セクションの高さ取得
    self.posYList = {};
    self._.times(self._.size(self.isOver), (idx) => {
      const num = idx + 1;
      if (num === 4) {
        return;
      }
      const key = `section${num}`;
      self.posYList[key] = self.$refs[key].offsetTop;
    });

    setTimeout(() => {
      self.isLoaded = true;
    }, 1000);

    window.addEventListener('scroll', self.handleScroll.bind(self));
  },
  methods: {
    handleMove(target) {
      this._.throttle(() => {
        this.jump(target, {
          duration: 800,
          offset: 0,
        });
      }, 500)();
    },

    handleScroll() {
      this._.throttle(() => {
        const self = this;
        if (window.pageYOffset + 10 > window.innerHeight) {
          self.btnTop.isShow = true;
        } else {
          self.btnTop.isShow = false;
        }

        // 各セクションを通り過ぎたか判定
        const currentTop = window.pageYOffset;
        const currentBottom = window.pageYOffset + window.innerHeight;
        let isAlreadyMatch = false;
        const times = self._.size(self.isOver);
        self._.times(times, (idx) => {
          const num = idx + 1;
          const nextNum = num + 1;
          const key = `section${num}`;
          const nextKey = `section${nextNum}`;
          if (!isAlreadyMatch &&
              currentTop >= self.posYList[key] &&
              (nextNum > times ||
               currentTop < self.posYList[nextKey])) {
            // self.$emit('currentUpdate', num);
            isAlreadyMatch = true;
          }

          if (!self.isOver[key] &&
              (currentBottom > self.posYList[key])) {
            self.isOver[key] = true;
          }
        });
      }, 300)();
    },

    handleEmailValid() {
      this._.debounce(() => {
        this.contact.email.invalid.format = !this.validEmail(
          this.contact.email.value,
        );
        this.contact.email.invalid.require = !this.validRequire(
          this.contact.email.value,
        );
        this.contact.isInvalid = this.getInvalid();
      }, 300);
    },

    handleContentValid() {
      this._.debounce(() => {
        this.contact.content.invalid.require = !this.validRequire(
          this.contact.content.value,
        );
        this.contact.isInvalid = this.getInvalid();
      }, 300);
    },

    handleSend() {
      this._.debounce(() => {
        const self = this;
        this.manageValid(() => {
          self.contact.isProgress = true;

          const jTypes = self.getTypeLabel();
          const params = {
            email: self.contact.email.value,
            type: jTypes,
            content: self.contact.content.value,
            user_agent: window.navigator.userAgent,
            country: window.navigator.language,
            page_type: 'home',
          };

          apiClient({
            url: CONST.API.CONTACT,
            method: 'post',
            data: params,
          })
          .then(() => {
            self.alertMessages = [
              '送信が完了しました。',
              'お問い合わせありがとうございます。',
            ];
            self.$refs.snackbar.open();
            self.contact.isProgress = false;

            // 最後の送信日を保持
            const lastDate = self._.now();
            localStorage.setItem(
              'lastContactTime',
              lastDate,
            );
            self.contact.isAlreadyLimit = true;
          })
          .catch(() => {
            self.alertMessages = [
              '送信が失敗しました。',
              [
                'お手数ですが、下記アドレスに送信をお願いします。',
                CONST.CONTACT.TO,
              ].join(''),
            ];
            self.$refs.snackbar.open();
            self.contact.isProgress = false;
          });
        });
      }, 500);
    },

    manageValid(callback) {
      this.handleEmailValid();
      this.handleContentValid();

      if (this.getInvalid()) {
        // アラート
        return;
      }

      callback();
    },

    validEmail(pattern) {
      const reg = /^([a-zA-Z0-9])+([a-zA-Z0-9¥._-])*@([a-zA-Z0-9_-]+\.)+([a-zA-Z0-9¥._-]+)+$/;
      return !!reg.test(pattern);
    },

    validRequire(pattern) {
      return !self._.isEmpty(self._.trim(pattern));
    },

    getInvalid() {
      return [
        this.contact.email.invalid.format,
        this.contact.email.invalid.require,
        this.contact.content.invalid.require,
        !this.validRequire(this.contact.email.value),
        !this.validRequire(this.contact.content.value),
      ].some(item => item);
    },

    getTypeLabel() {
      const self = this;
      return self._.find(
        self.config.contact.types,
        { id: self.contact.type.value },
      ).label;
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/home/index.js